// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Plate$BwaxMobile = require("../../../../bwax-js/ml/plate.bs.js");
var Lang_eval$BwaxMobile = require("../../../../bwax-js/ml/lang/lang_eval.bs.js");
var Query_entry$BwaxMobile = require("../../../../bwax-js/ml/query/query_entry.bs.js");
var Lang_mod_json$BwaxMobile = require("../../../../bwax-js/ml/lang/mod/builtin/lang_mod_json.bs.js");
var Widget_common$BwaxMobile = require("./widget_common.bs.js");
var Runtime_common$BwaxMobile = require("../../../../bwax-js/ml/lang/mod/runtime_common.bs.js");
var Admin_page_common$BwaxMobile = require("../../admin/admin_page_common.bs.js");

var module_name = "AdminPage";

var src = "\n\nmodule " + (String(module_name) + ";\n\nimport Element exposing (Length, Element);\n\n-- 以下是 Admin 专用的：\n\ntype Widget msg = opaque;\ntype ButtonType = Primary | Default | Link | Subtle | Ghost | Danger;  -- Danger 等于 primary + red\n\ntype alias ConfirmSetting = \n  { title: String !\n  , okText: String \n  , cancelText: String\n  -- , placement: String\n  }\n;\n\n-- \ntype alias FieldItem a msg = \n  { name: String!\n  , path: String \n  , inputParams: JSON\n  , displayParams: JSON\n  , applicable: # a -> Bool\n  , requiredIf: # a -> Bool\n  , editable: # a -> Bool \n  \n  , defaultView: # a -> Element msg -- 用于展示如果 A 不存在则默认会使用 B 字段代替的情况\n                                    -- 也许这个逻辑可以放入字段设置里。\n\n  }\n;\n\n\n-- 针对于特定 record 的 operation\ntype RecordOp a = \n  | GotoDetail ~{ url: String -> String, tab: String }  \n        -- by default url is  /entities/<entityName>/records/:id\n        -- if url is given, tab will not be used.\n  | UpdateRecord (UpdatingForm a)\n  | DeleteRecord\n  | Custom (RecordOperation a)\n;\n\n\ntype PopupType = Popover | Drawer | Modal;\n\n\ntype Action a msg =\n  -- 设定表单上出现的字段（必填字段会自动加上去），默认值，初始值，固定值\n  -- 当固定值涵盖了所有的字段时，则直接添加成功； 否则，默认弹出一个 Popup\n  | AddRecordAction \n     ~{ items: List (~ FieldItem a msg)\n      --, itemLists: List (List (~ FieldItem a msg))  -- 可以同时存在，但 itemLists 的优先级大于 items.\n      , defaultValues: AddingForm a\n      , initialValues: AddingForm a\n      , fixedValues: AddingForm a \n      , popupType: PopupType  -- 默认为 Popover\n      }\n\n  -- 弹窗提供 record 的选择， 选择并点击确定后执行 record operation\n  | RecordOpAction \n     ~{ op: RecordOp a !\n      , title: String\n      , recordQuery: QueryConfig a  -- 可选的预设查询条件\n      , popupType: PopupType  -- 默认为  Popover\n      }\n  \n\n  -- 设定表单上出现的字段，固定值\n  -- 当固定值涵盖了所有的字段时，则直接修改； 否则弹出一个 Popup\n  | UpdateRecordAction \n     ~{ items: List (~ FieldItem a msg )\n      , fixedValues: UpdatingForm a\n      , popupType: PopupType \n      }\n      String\n\n--  | CustomAction Operation JSON\n  | ExtAction String (Maybe JSON)  -- name args \n;\n\n-- The widgets: record table\ntype alias FieldColumn a =\n  { name: String!\n  , path: String  -- 如果同时出现 path 和 compose， 则以 compose 为准\n  , compose: # a -> ~\n\n  , editingAllowed: # a -> Bool \n  , width: Int  \n  , fixedLeft: Bool   -- width and fixedLeft are default values, changeable by user preference.\n  , displayParams: JSON\n  , inputParams: JSON\n\n  }\n;\n\n\n\ntype alias ActionButton a msg = \n  { label: String!, action: Action a msg !\n  , applicable: # a -> Bool  \n  , disabled: # a -> Bool\n  , buttonType: ButtonType, buttonColor: Color\n  , confirm: ConfirmSetting \n  }\n; \n\ntype alias RecordOperationButton a = \n  { label: String !, op: RecordOp a !\n  , applicable: # a -> Bool -- 这应该是一个纯函数，要考虑加入其他环境变量吗？\n  , disabled: # a -> Bool\n  , buttonType: ButtonType, buttonColor: Color\n  , confirm: ConfirmSetting \n  }\n;\n\ntype alias RecordTableConfig a msg = \n  { id: String -- used to preserve the user preferences.\n  , title: String -- displayed as title\n\n  , description: String -- displayed as subtitle\n\n  , allowEditByDefault: Bool -- by default this is false, which means \"not allow\"\n\n  , fieldColumns: List (~ FieldColumn a)\n  , operations: List (~ RecordOperationButton a) \n  , topRightButtons: List (~ ActionButton a msg)\n  , topRightMenuButtons: List (~ ActionButton a msg)\n\n  , excludedFields: List String -- applied only when the fieldColumns is not present.\n  , showRowNum: Bool -- by default it is true.\n\n  , pageSizeOptions: List Int -- 1) the first page size will be the default one\n                              -- 2) if [] is given, there\'s no page size selection, in this case the page size is 10\n                              -- 3) by default it is [10, 20, 50, 100]\n                              -- 4) if only one option is given, the one option is used and there\'s no page size selection.\n\n  -- the top right icon buttons:\n  , noRefresh: Bool\n  , noExport: Bool\n  , noSetting: Bool\n  , noFilter: Bool\n  , noSearch: Bool\n\n  , exportConfig: ~ { excludedColumns: List String }\n\n  , searchConfig: ~ { additionalFields: List String }  -- 使用 path\n\n  }\n;\n\ntype FormLayout = Horizontal | Vertical | Inline;\n\ntype alias RecordCardConfig a msg =\n  { itemLists: List (List (~ FieldItem a msg))  -- could be multi-columns\n  , items: List (~ FieldItem a msg)             -- 如果同时有 itemLists 和 items，优先使用 itemLists\n  , layout: FormLayout\n\n  , title: String\n  , id: String  -- used to preserve user settings.\n\n  , description: String -- displayed as subtitle\n\n  , noLabel: Bool -- 建议只用于 Vertialcal 或者 Inline\n\n  , editInPlace: Bool -- 默认为 False，即弹起 Modal 编辑\n\n  , operations: List (~ RecordOperationButton a)\n\n  , menuOperations: List (~ RecordOperationButton a)\n\n  , buttonForEmptyState: ~ ActionButton a msg\n\n  }\n;\n\nrecordTable: QueryConfig a -> ~ RecordTableConfig a msg -> Widget msg = external;\n\nrecordCard: QueryConfig a -> ~ RecordCardConfig a msg -> Widget msg = external;\n\n\n-- Use BwaxUI:\n\nrecordView: QueryConfig a \n  -> ~{ title: String, id : String, description: String }   \n  -> (# a -> Element msg)       -- view\n  -> Widget msg = external;\n\nrecordListView: QueryConfig a \n  -> ~{ title: String, id : String, description: String \n      , pageSizeOptions: List Int -- 1) the first page size will be the default one\n                              -- 2) if [] is given, there\'s no page size selection, in this case the page size is 10\n                              -- 3) by default it is [10, 20, 50, 100]\n                              -- 4) if only one option is given, the one option is used and there\'s no page size selection. \n\n\n      } \n  ->  (# a -> Element msg) -- view\n  -> Widget msg = external;\n\n\nelementView: ~{ title: String, description: String  } ->  Element msg -> Widget msg = external; \n\n\ndummy: Color -> Widget msg = external;\n\n\ntype alias WidgetBox msg =\n  { widgets: List (Widget msg)\n  -- , span: Maybe Int -- 1 2 3\n  , height: Maybe Int -- Pixel\n  }\n;\n\n\nwidgetBox height widget = { widgets = [ widget ], height };\n\n-- do not use this.\n-- box height widget = { widgets = [ widget ], height }\n;\n\n\ntype Wide msg = \n  | OneColumn (List (WidgetBox msg))\n  | TwoColumns (List (WidgetBox msg)) (List (WidgetBox msg))\n;\n\ntype Side = Left | Right;\n\ntype PageLayout msg = \n  | WideAndNarrow (List (Wide msg)) (List (WidgetBox msg))                    -- Wide list and narrow list\n  | Full (List (WidgetBox msg)) (List (Wide msg)) (List (WidgetBox msg))      -- Top list, wide list and narrow list.\n  | WidgetAndBar Side (Maybe Float) (Widget msg) (List (WidgetBox msg))         \n          -- Left/Right, side bar widget (pct, 1/3 by default), main widget, widget list in bar\n;\n\ntype TabPage msg = Layout (PageLayout msg) | Single (Widget msg);\n\n-- Admin Page 返回 PageLayout, List (String, TabPage), 或者 Widget\n\n-- 而不再是 PageScheme\n-- type PageScheme = \n--  | Single PageLayout\n--  | Multi (List (String, PageLayout))  -- used for tabs\n--  | OneWidget Widget\n;\n\n\n\n");

function fail(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

function convert_config_to_js(config) {
  var query_config_processor = function (v) {
    return Caml_option.some(Query_entry$BwaxMobile.make_query_config(v));
  };
  var processors_000 = /* tuple */[
    "__QueryConfig__",
    query_config_processor
  ];
  var processors = /* :: */[
    processors_000,
    /* [] */0
  ];
  return Plate$BwaxMobile.$$Option.with_default(null, Lang_mod_json$BwaxMobile.any_value_to_json(/* record */[
                  /* keeping_native */true,
                  /* nothing_to_null */true,
                  /* processors */processors
                ], config));
}

function make_view_func(func_val, v) {
  var match = Lang_eval$BwaxMobile.apply_value(undefined, func_val, v, Runtime_common$BwaxMobile.nt);
  var match$1 = match[0];
  if (typeof match$1 === "number") {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "View func does not yield element"
        ];
  } else if (match$1.tag === /* V_raw */7) {
    return match$1[0];
  } else {
    throw [
          Lang_eval$BwaxMobile.Eval_exn,
          "View func does not yield element"
        ];
  }
}

var recordTable = Runtime_common$BwaxMobile.pack_func(2, (function (param) {
        if (param) {
          var match = param[1];
          if (match && !match[1]) {
            var query_config = Query_entry$BwaxMobile.make_query_config(param[0]);
            var config_js = convert_config_to_js(match[0]);
            return Admin_page_common$BwaxMobile.widget_to_value(/* Record_table */Block.__(2, [
                          query_config,
                          config_js
                        ]));
          } else {
            return fail("recordTable");
          }
        } else {
          return fail("recordTable");
        }
      }));

var externals_vals_000 = /* tuple */[
  "dummy",
  Runtime_common$BwaxMobile.pack_func(1, (function (param) {
          if (param && !param[1]) {
            var color = Widget_common$BwaxMobile.make_color(param[0]);
            return Admin_page_common$BwaxMobile.widget_to_value(/* Dummy_widget */Block.__(0, [color]));
          } else {
            return fail("dummy");
          }
        }))
];

var externals_vals_001 = /* :: */[
  /* tuple */[
    "elementView",
    Runtime_common$BwaxMobile.pack_func(2, (function (param) {
            if (param) {
              var match = param[1];
              if (match) {
                var match$1 = match[0][0];
                if (typeof match$1 === "number" || !(match$1.tag === /* V_raw */7 && !match[1])) {
                  return fail("elementView");
                } else {
                  var config_js = convert_config_to_js(param[0]);
                  return Admin_page_common$BwaxMobile.widget_to_value(/* Element_view */Block.__(1, [
                                config_js,
                                match$1[0]
                              ]));
                }
              } else {
                return fail("elementView");
              }
            } else {
              return fail("elementView");
            }
          }))
  ],
  /* :: */[
    /* tuple */[
      "recordTable",
      recordTable
    ],
    /* :: */[
      /* tuple */[
        "recordList",
        recordTable
      ],
      /* :: */[
        /* tuple */[
          "recordCard",
          Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                  if (param) {
                    var match = param[1];
                    if (match && !match[1]) {
                      var query_config = Query_entry$BwaxMobile.make_query_config(param[0]);
                      var config_js = convert_config_to_js(match[0]);
                      return Admin_page_common$BwaxMobile.widget_to_value(/* Record_card */Block.__(3, [
                                    query_config,
                                    config_js
                                  ]));
                    } else {
                      return fail("recordCard");
                    }
                  } else {
                    return fail("recordCard");
                  }
                }))
        ],
        /* :: */[
          /* tuple */[
            "recordView",
            Runtime_common$BwaxMobile.pack_func(3, (function (param) {
                    if (param) {
                      var match = param[1];
                      if (match) {
                        var match$1 = match[1];
                        if (match$1 && !match$1[1]) {
                          var query_config = Query_entry$BwaxMobile.make_query_config(param[0]);
                          var config_js = convert_config_to_js(match[0]);
                          return Admin_page_common$BwaxMobile.widget_to_value(/* Record_view */Block.__(4, [
                                        query_config,
                                        config_js,
                                        match$1[0]
                                      ]));
                        } else {
                          return fail("recordView");
                        }
                      } else {
                        return fail("recordView");
                      }
                    } else {
                      return fail("recordView");
                    }
                  }))
          ],
          /* :: */[
            /* tuple */[
              "recordListView",
              Runtime_common$BwaxMobile.pack_func(3, (function (param) {
                      if (param) {
                        var match = param[1];
                        if (match) {
                          var match$1 = match[1];
                          if (match$1 && !match$1[1]) {
                            var query_config = Query_entry$BwaxMobile.make_query_config(param[0]);
                            var config_js = convert_config_to_js(match[0]);
                            return Admin_page_common$BwaxMobile.widget_to_value(/* Record_list_view */Block.__(5, [
                                          query_config,
                                          config_js,
                                          match$1[0]
                                        ]));
                          } else {
                            return fail("recordListView");
                          }
                        } else {
                          return fail("recordListView");
                        }
                      } else {
                        return fail("recordListView");
                      }
                    }))
            ],
            /* :: */[
              /* tuple */[
                "box",
                Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                        if (param) {
                          var match = param[1];
                          if (match && !match[1]) {
                            console.log("Warining: use widgetBox instead");
                            var l_000 = /* tuple */[
                              "widgets",
                              /* tuple */[
                                /* V_list */Block.__(1, [/* :: */[
                                      match[0],
                                      /* [] */0
                                    ]]),
                                Runtime_common$BwaxMobile.nt
                              ]
                            ];
                            var l_001 = /* :: */[
                              /* tuple */[
                                "height",
                                param[0]
                              ],
                              /* [] */0
                            ];
                            var l = /* :: */[
                              l_000,
                              l_001
                            ];
                            return /* tuple */[
                                    /* V_record */Block.__(2, [l]),
                                    Runtime_common$BwaxMobile.nt
                                  ];
                          } else {
                            return fail("box");
                          }
                        } else {
                          return fail("box");
                        }
                      }))
              ],
              /* [] */0
            ]
          ]
        ]
      ]
    ]
  ]
];

var externals_vals = /* :: */[
  externals_vals_000,
  externals_vals_001
];

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  externals_vals
];

var command_handlers = /* [] */0;

exports.module_name = module_name;
exports.src = src;
exports.fail = fail;
exports.convert_config_to_js = convert_config_to_js;
exports.make_view_func = make_view_func;
exports.recordTable = recordTable;
exports.externals_vals = externals_vals;
exports.command_handlers = command_handlers;
exports.externals = externals;
/* src Not a pure module */
